import Layout from '@/app/component/layout/page'
import { AuthGuard, AuthHeader } from '@/app/module/auth'
import VerifyOTPForm from '@/app/module/auth/component/verify-otp'
import Notifications from '@/app/module/notifications'

export default function VerifyOTPPage(props: any) {
  const { name, match } = props
  return (
    <AuthGuard url={match.url} path={match.path}>
      <Layout title="Two-factor Authentication - engageSPARK">
        <AuthHeader currentPage={name} />
        <VerifyOTPForm />
        <Notifications />
      </Layout>
    </AuthGuard>
  )
}
